import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'projects/store/src/environments/environment';
import { CountryCode } from 'projects/store/src/app/enums';
import { PhoneAppState, PhoneAppStatusService } from 'projects/store/src/app/services/api/v1/phone-app-status.service';

interface DatacultrStep {
  number: number;
  text: string;
}

@Component({
  selector: 'app-sales-phone-datacultr-platform',
  templateUrl: './sales-phone-datacultr-platform.component.html',
  styleUrls: ['./sales-phone-datacultr-platform.component.scss']
})
export class SalesPhoneDatacultrPlatformComponent implements OnInit, OnDestroy {
  @Input() requestId!: string;
  @Input() otp?: string | null;
  @Input() contractNumber?: string | null;
  @Input() personNumber?: string | null;
  @Output() nextStep = new EventEmitter<void>();

  appState: PhoneAppState = PhoneAppState.Waiting;

  private subscription?: Subscription;

  readonly isMexico = environment.global.country.code === CountryCode.MX;
  readonly isColombia = environment.global.country.code === CountryCode.CO;

  constructor(private status: PhoneAppStatusService) {}

  ngOnInit(): void {
    if (this.isColombia) {
      // Caso especial CO: no bloquear, ready inmediato sin polling
      this.appState = PhoneAppState.Ready;
      return;
    }

    // Resto de países (MX, PA, GT, HN, SV, PE): polling via app/status
    this.subscription = this.status.state$.subscribe(state => {
      this.appState = state;
    });
    this.status.start(this.requestId);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.status.stop();
  }

  onContinue(): void {
    this.nextStep.emit();
  }

  get displaySubTitle(): string {
    return this.isMexico
      ? 'Para continuar, necesitamos que abras la app de Krediya que ha sido instalada, para que puedas reportar tus pagos.'
      : 'Todo listo para entregar!';
  }

  get steps(): DatacultrStep[] {
    return [
      { number: 1, text: 'Recuérdale al cliente buscar en su Play Store KRDYA y descargar la aplicación.' },
      { number: 2, text: 'Abrir la app.' },
      { number: 3, text: 'Ingresar su número de cédula o teléfono.' },
      { number: 4, text: `Ingresar el PIN ${this.otp ?? ''} para crear su contraseña.` }
    ];
  }
}
